module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }